import { useRef, useEffect, FC } from 'react';
import { colors } from 'theme/config'

type Props = {
    text: string;
    show: boolean;
}

const ratio = 4;

export const TextImage: FC<Props> = ({ text, show }) => {
    const ref = useRef(null);

    useEffect(() => {        
        const node = ref.current;
        if (!node) return;

        const ctx = node.getContext('2d');
        ctx.font = '16px Roboto';

        const width = Math.round(ctx.measureText(text).width);

        node.width = width * ratio;
        node.style.width = width;

        const fontSize = 16 * ratio;

        ctx.font = `${fontSize}px Roboto`;
        ctx.fillStyle = colors.text.base;

        ctx.fillText(text, 0, 15 * ratio);
    }, [ref, text, show])

    if (show) {
        return <>{ text }</>;
    }

    return <canvas ref={ref} height={20 * ratio} style={{height: 20, marginTop: 2.5}}></canvas>
}